import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Drawer, Box, Typography, IconButton, Button, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useCart } from '../../context/CartContext';
import CartItem from './CartItem';
import GradientButton from '../common/GradientButton';

export default function CartDrawer() {
  const navigate = useNavigate();
  const { storeSlug } = useParams();
  const { items, isDrawerOpen, setDrawerOpen, subtotal, cartKey } = useCart();
  const prefix = storeSlug ? `/store/${storeSlug}` : '';

  return (
    <Drawer anchor="right" open={isDrawerOpen} onClose={() => setDrawerOpen(false)}>
      <Box sx={{ width: { xs: 320, sm: 400 }, height: '100%', display: 'flex', flexDirection: 'column', p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Cart ({items.length})
          </Typography>
          <IconButton onClick={() => setDrawerOpen(false)}><CloseIcon /></IconButton>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {items.length === 0 ? (
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
            <ShoppingCartIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
            <Typography color="text.secondary">Your cart is empty</Typography>
            <Button variant="outlined" onClick={() => { setDrawerOpen(false); navigate(`${prefix}/products`); }}>
              Browse Products
            </Button>
          </Box>
        ) : (
          <>
            <Box sx={{ flex: 1, overflowY: 'auto', mb: 2 }}>
              {items.map(item => (
                <CartItem key={cartKey(item)} item={item} />
              ))}
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Subtotal</Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>${subtotal.toFixed(2)}</Typography>
            </Box>

            <GradientButton
              fullWidth
              onClick={() => { setDrawerOpen(false); navigate(`${prefix}/checkout`); }}
              sx={{ mb: 1 }}
            >
              Checkout
            </GradientButton>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => { setDrawerOpen(false); navigate(`${prefix}/cart`); }}
            >
              View Cart
            </Button>
          </>
        )}
      </Box>
    </Drawer>
  );
}
